import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
// import cx from 'classnames';
// import { phoneNormalize } from 'shared/modules';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';
import DealerSocials from 'shared/components/DealerSocials/DealerSocials';
import { AvatarIcon } from 'shared/components/Icons';
import withAdvertPhoneView from 'shared/hocs/withAdvertPhoneView';
import { withTranslate } from 'shared/hocs/withTranslate';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import Link from 'shared/components/Link/Link';
import { ContactPhoneButton } from 'shared/components/UI';

import s from './AdvertSeller.css';

const isMobile = __APP__ === 'mobile';

class AdvertSeller extends React.Component {
  static propTypes = {
    advertID: PropTypes.number,
    authorName: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    location: PropTypes.string.isRequired,
    // authorEmail: PropTypes.string,
    avatar: PropTypes.string,
    link: PropTypes.string,
    agency: PropTypes.shape(),
    extraText: PropTypes.string,
    requestShowPhones: PropTypes.func.isRequired,
    phones: PropTypes.arrayOf(PropTypes.string),
    messengers: PropTypes.arrayOf(PropTypes.shape()),
    sold: PropTypes.bool,
    active: PropTypes.number,
    setRatioImage: PropTypes.func.isRequired,
    isApprovePub: PropTypes.bool,
    advert: PropTypes.shape(),
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    authorName: '',
    advertID: null,
    agency: null,
    avatar: null,
    link: null,
    extraText: null,
    phones: null,
    messengers: null,
    sold: false,
    active: 1,
    advert: null,
    isApprovePub: false,
  };

  handleShowPhoneClick = cb => {
    const { advertID, requestShowPhones } = this.props;
    if (advertID) {
      requestShowPhones(advertID, true, phones => cb(phones));
    }
  };

  render() {
    const {
      authorName,
      location,
      avatar,
      link,
      extraText,
      phones,
      agency,
      sold,
      setRatioImage,
      active,
      isApprovePub,
      t,
    } = this.props;
    const website = agency && agency.website ? agency.website : null;
    const avatarImg = 'https://img.freepik.com/free-photo/horizontal-shot-handsome-charismatic-young-man-with-black-hair-stubble-posing-isolated-pointing-fore-fingers-having-confident-flirty-facial-expression-choosing-you-body-language_343059-4555.jpg?size=626&ext=jpg'; // avatar && setRatioImage(avatar.replace('http:', 'https:'), 40);
    const isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
    const messengers =
      agency && agency.messengers && !!agency.messengers.length && agency.messengers;
    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClass}>
        <div className={s.rowContainer}>
          {avatar && <img className={s.avatar} alt={''} src={avatarImg} />}
          {!avatar &&
            <div className={s.avatarPlaceholder}>
              <AvatarIcon />
            </div>}
          {authorName &&
            <div className={s.nameContainer}>
              <div className={s.sallerTitle}>
                <FormattedMessage id="Продавец" />
              </div>
              <Link to={link || null} className={link ? s.authorLink : s.colAuto}>
                {authorName}
                {extraText &&
                  <span className={s.authorExtraText}>
                    {extraText}
                  </span>}
              </Link>
            </div>}
          {/* <div className={s.row}>
            <div className={s.col}>
              <FormattedMessage id="Адрес" />
            </div>
            <div className={s.colAuto}>
              {location}
            </div>
          </div> */}
        </div>
        <div className={s.flexColumnBlock}>
          <div className={s.flexRowBlock}>
            {website &&
              <div className={s.write}>
                <DealerWebsiteLink dealer={agency} ClassName={s.writeBtn} />
              </div>}

            {/* <ContactPhoneButton clickHandler={this.handleShowPhoneClick} phones={phones || []} /> */}
            {!isDeactivated && <ContactPhoneButton loadPhones={this.handleShowPhoneClick} />}

            {/* {!isDeactivated &&
              <div className={s.contact}>
                <div
                  className={cx(s.contactBtn, { [s.showedPhone]: phones && phones.length > 0 })}
                  onClick={this.handleShowPhoneClick}
                >
                  {phones &&
                    !phones.length &&
                    <div>
                      <FormattedMessage id="Нет телефонов" />
                    </div>}
                  {phones &&
                    phones.length > 0 &&
                    phones.map(phone =>
                      <div key={phone} className={cx(s.phoneList, s.phone)}>
                        <a href={`tel:${phoneNormalize(phone)}`}>
                          {phoneNormalize(phone)}
                        </a>
                      </div>,
                    )}
                  {!phones &&
                    <div>
                      <div data-lens-event="showPhoneClick">
                        {t('Показать телефон')}
                      </div>+••• •• ••• •• ••
                    </div>}
                </div>
              </div>} */}
          </div>
          {messengers &&
            <div className={s.messengersBlock}>
              <DealerSocials messengers={messengers} />
            </div>}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withAdvertPhoneView(withPixelRatio(withTranslate(AdvertSeller))));



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertSeller/AdvertSeller.js